var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"resend-text primary-color"},[_vm._v("\n    "+_vm._s(_vm.$t('opt-login.resendcode'))+" "+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }